module.exports = __webpack_public_path__ + "static/img/loading-3-en.098b309.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/load/img/loading-3-en.png
// module id = BMh3
// module chunks = 1